/* eslint-disable */

import React from 'react'
import { useReactTable, getCoreRowModel, flexRender } from "@tanstack/react-table"
import { NoMatchesFoundContainer, ClearFiltersLink, StyledTable, StyledDiv } from './style'
import { FormattedMessage } from 'react-intl'
import LoadingWrapper from '../LoadingWrapper'

const Table = ({
  rowOnClick,
  rows,
  columns,
  dataTest,
  clearFilters,
  clearFiltersMessage = 'clearFilters',
  noResultMessage = 'noMatchingFilterCriteria',
  isLoading,
  height,
  noClearFilter = false,
  lastElementRef,
  overflow = true
}) => {
  const table = useReactTable({
    data: rows,
    columns,
    getCoreRowModel: getCoreRowModel(),
  })

  const {
    getHeaderGroups,
    getRowModel,
  } = table

  return (
    <StyledDiv height={height} className="scroll" data-test={dataTest}  overflow={overflow}>
      <LoadingWrapper size={'24px'} isLoading={isLoading}>
        <StyledTable>
          <table>
            <thead
              style={{
                background: 'rgba(32, 32, 32, 0.05)'
              }}
            >
              {getHeaderGroups().map((headerGroup) => {
                return (
                  <tr key={headerGroup.id}>
                    {headerGroup.headers.map((header) => {
                      return (
                        <th
                          key={header.id}
                          style={header.column.columnDef.style}
                          colSpan={header.colSpan}
                        >
                          {flexRender(header.column.columnDef.header, header.getContext())}
                        </th>
                      )
                    })}
                  </tr>
                )
              })}
            </thead>
            <tbody>
              {getRowModel().rows.map((row, index) => {
                if(index + 1 === getRowModel().rows.length && typeof lastElementRef !== 'undefined') {
                  return (
                    <tr
                      key={row.id}
                      ref={lastElementRef}
                      onClick={ rowOnClick ? ()=>{
                        rowOnClick(
                          row.original.id,
                          row.original.historyId,
                          row.original.siteStatusId,
                          row.original.monitoringId
                        )
                      } : () => {}}
                    >
                      {row.getVisibleCells().map((cell) => {
                        return (
                          <td key={cell.id} style={cell.column.columnDef.style}>
                            {flexRender(cell.column.columnDef.cell, cell.getContext())}
                          </td>
                        )
                      })}
                    </tr>
                  )
                }
                return (
                  <tr
                    key={row.id}
                    onClick={ rowOnClick ? ()=>{
                      rowOnClick(
                        row.original.id,
                        row.original.historyId,
                        row.original.siteStatusId,
                        row.original.monitoringId
                      )
                    } : () => {}}
                  >
                    {row.getVisibleCells().map((cell) => {
                      return (
                        <td key={cell.id} style={cell.column.columnDef.style}>
                          {flexRender(cell.column.columnDef.cell, cell.getContext())}
                        </td>
                      )
                    })}
                  </tr>
                )
              })}
            </tbody>
          </table>
        </StyledTable>
        {!rows.length && (
          <NoMatchesFoundContainer data-test="no-data-clear-filters">
            <FormattedMessage id={noResultMessage} />
            {noClearFilter ? (
              <></>
            ) : (
              <div>
                <ClearFiltersLink onClick={() => clearFilters()}>
                  <FormattedMessage id={clearFiltersMessage} />
                </ClearFiltersLink>
              </div>
            )}
          </NoMatchesFoundContainer>
        )}
      </LoadingWrapper>
    </StyledDiv>
  )
}

export default Table